<template>
  <div id="footerComponent" class="container-fluid secondary-bg ">
    <div class="row">
      <div class="col-12 text-center">
        <img
            alt="لوگو"
            class="my-4"
            src="../../assets/img/logo.png"
            style="max-height: 40px"/>
      </div>
      <div class="col-md-3">
        <div class="primary-text font-16 text-center text-md-right">آموزش املاک</div>
        <div class="white--text mt-4">
          هدف آکادمی کاشانی کیا ارتقا و افزایش سطح علمی مشاورین املاک و صاحبان آژانسهای املاک در زمینه مبانی دلالی علمی
          املاک و پیادهسازی سیستم مدیریت کیفیت در سراسر ایران بوده. آکادمی کاشانی کیا دارای مجوز رسمی نشر دیجیتال سرآمد
          از وزارت فرهنگ و ارشاد اسلامی بوده و فعالیتهای ما در راستای فرهنگسازی و افزایش سطح علمی صنف املاک و دلالان
          بازار املاک است
        </div>

      </div>
      <div class="col-md-auto mx-auto  p-0">
        <div class="row">
          <div class="col-12   pb-0 ">
            <div class="primary-text font-16 text-center text-md-right">خدمات</div>
          </div>
          <div class="col-6 col-md-auto ">
            <div v-for="(item ,i) in servicesItemsPartOne" :key="i">
              <router-link :to="{path:'Services' , query:{id: item.id}}">
                <span class="ml-2 font-16">.</span>{{ item.text }}
              </router-link>
            </div>
          </div>
          <div class="col-6 col-md-auto  ">
            <div v-for="(item ,i) in servicesItemsPartTwo" :key="i">
              <router-link :to="{path:'Services' , query:{id: item.id}}">
                <span class="ml-2 font-16">.</span> {{ item.text }}
              </router-link>
            </div>
          </div>
        </div>

      </div>

      <div class="col-md-3">
        <div class="primary-text font-16 text-center text-md-right">ارتباط با ما</div>
        <div class="white--text text-center text-md-right mt-3"> تلفن تماس: <a href="tel:09126111882">09126111882</a> -
          <a href="tel:02144225956">02144225956</a></div>
        <div class="white--text text-center text-md-right">
          همت غرب، خیابان کبیری طامه (شاهین شمالی)، بالاتر از تقاطع مخبری، نبش بن بست پیام، پلاک۲، طبقه اول، واحد ۴
        </div>
        <a referrerpolicy="origin" target="_blank"
           href="https://trustseal.enamad.ir/?id=321683&amp;Code=AOF8nrnxefZgJQsldSFl"><img referrerpolicy="origin"
                                                                                            src="https://Trustseal.eNamad.ir/logo.aspx?id=321683&amp;Code=AOF8nrnxefZgJQsldSFl"
                                                                                            alt=""
                                                                                            style="cursor:pointer"
                                                                                            id="AOF8nrnxefZgJQsldSFl"></a>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Footer-component",
  data: () => ({
    servicesItemsPartOne: [
      {
        id: 1,
        text: "مشاوره خصوصی",
        path: "/"
      },
      {
        id: 2,
        text: "فرانچایز",
        icon: "",
        path: "/"
      },
      {
        id: 3,
        text: "برگزاری همایش",
        icon: "",
        path: "/"
      },
      {
        id: 4,
        text: "برگزاری ورکشاپ در شهر شما",
        icon: "",
        path: "/"
      },

      {
        id: 5,
        text: "دریافت نمایندگی",
        icon: "",
        path: "/"
      },
      {
        id: 6,
        text: "ساخت آژانس املاک",
        icon: "",
        path: "/"
      },
    ],
    servicesItemsPartTwo: [
      {
        id: 7,
        text: "صدور مدارک فنی حرفه ای و بین المللی",
        icon: "",
        path: "/"
      },
      {
        id: 8,
        text: "خدمات حقوقی مسکن و املاک",
        icon: "",
        path: "/"
      },
      {
        id: 9,
        text: "هوشمندسازی فایلینگ املاک",
        icon: "",
        path: "/"
      },
      {
        id: 10,
        text: "ساخت و اپلیکیشن املاک",
        icon: "",
        path: "/"
      },
      {
        id: 11,
        text: "ایران زیلو",
        icon: "",
        path: "/"
      }
    ]
  })
}
</script>

<style scoped>

</style>
